export const MessageTypes = {
  GRAPHQL_REQUEST: 'graphql-request',
  GRAPHQL_RESPONSE: 'graphql-response',
  GRAPHQL_ERROR: 'graphql-error',
  GRAPHQL_SUBSCRIBE: 'graphql-subscribe',
  GRAPHQL_SUBSCRIPTION_COMPLETE: 'graphql-subscription-complete',
  GRAPHQL_SUBSCRIPTION_DATA: 'graphql-subscription-data',
  GRAPHQL_SUBSCRIPTION_ERROR: 'graphql-subscription-error',
  GRAPHQL_UNSUBSCRIBE: 'graphql-unsubscribe',
};
